import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';
import { queryClient } from '../../queryClient';

interface HookProps {
  batchId: string;
  fileName: string;
}

export const useGenerateBatchRiskAnalysisReport = () => {
  return useMutation({
    mutationFn: async ({ batchId }: HookProps) => {
      await request({
        path: `batches/generate-risk-analysis-report`,
        method: 'POST',
        authenticate: true,
        fileDownload: true,
        dataObject: { batchId },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getUserReports'] });
      toast.success('The report is being generated.');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating the report!');
    },
  });
};
